import type { CreateSerieRequest, ResponsiblePersonInput } from '@/api/generated/schemas';
import { SerieTransportType } from '@/api/generated/schemas';
import { RESPONSIBILITY_ROLE_FIELDS } from '@/modules/products/venua-planner/responsibleRoles';
import type { SerieFormValues, TransportTypeValue } from './serieFormSchema';

const TRANSPORT_TYPE_TO_API: Record<TransportTypeValue, SerieTransportType> = {
  flight: SerieTransportType.Flight,
  bus: SerieTransportType.Bus,
  combined: SerieTransportType.Combined,
};

/** Mapuje vyplněné odpovědné osoby na API vstup (každá vyplněná role je origin). Sdílené série/produkt. */
export function toResponsiblePersonInputs(values: SerieFormValues): ResponsiblePersonInput[] {
  return RESPONSIBILITY_ROLE_FIELDS.flatMap((field) => {
    const person = values.responsiblePersons[field.key];
    if (!person) return [];
    return [{ role: field.role, isOverridden: true, personPartyId: person.partyId }];
  });
}

function normalizeNote(note: string): string | null {
  const trimmed = note.trim();
  return trimmed.length > 0 ? trimmed : null;
}

/** Transformace hodnot formuláře na API request pro založení série. */
export function toCreateSerieRequest(values: SerieFormValues): CreateSerieRequest {
  return {
    name: values.name.trim(),
    transportType: TRANSPORT_TYPE_TO_API[values.transportType],
    note: normalizeNote(values.note),
    responsiblePersons: toResponsiblePersonInputs(values),
  } satisfies CreateSerieRequest;
}

export { TRANSPORT_TYPE_TO_API, normalizeNote };
